import React from 'react';

import Routes from  './routes';

import './style.css';

function App() {
  return (
    <Routes/>
    
  );
}

export default App;
